<template>
  <div>
    <vs-chip v-if="VALUE == 2" color="#24c1a0">
      Sevk Tamamlandı
    </vs-chip>
    <vs-chip v-else color="danger">
      Henüz Tamamlanmadı
    </vs-chip>
  </div>
</template>
<script>
export default {
  data() {
    return {
      VALUE: "",
    };
  },
  created() {
    this.VALUE = this.params.value;
  },
};
</script>
    